import { useMemo } from 'react';
import { ApolloProvider } from '@apollo/client';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { createApolloClient } from 'hubspot-apollo-client';
import PortalIdParser from 'PortalIdParser';
import ExternalPageDetailsPage from '../components/externalPages/ExternalPageDetailsPage';
import useQueryParams from '../hooks/useQueryParams';
import { useAppSelector } from '../reducers';
import { selectAuthState } from '../selectors';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DFCProvider({
  children
}) {
  const client = useMemo(() => {
    return new DataFetchingClient();
  }, []);
  const apolloClient = useMemo(() => createApolloClient(), []);
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: client,
      children: children
    })
  });
}
const ExternalPagesDetailsContainer = () => {
  const queryParams = useQueryParams();
  const title = queryParams.get('title');
  const url = queryParams.get('url');
  const userInfo = useAppSelector(selectAuthState);
  if (!userInfo.user) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (!url) {
    return /*#__PURE__*/_jsxs(ErrorMessage, {
      type: "notFound",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.externalPageNotFound.errorTitle"
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: `/analytics/${PortalIdParser.get()}/pages`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.externalPageNotFound.backLink"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(DFCProvider, {
    children: /*#__PURE__*/_jsx(ExternalPageDetailsPage, {
      title: title || I18n.text('page-details-ui.externalPageUnknownTitle'),
      url: url
    })
  });
};
export default ExternalPagesDetailsContainer;